
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M50.686 17.79c-.4-.6-.8.2-.9.6-.3.9-2.8 1.7-3.5 1.9-1.7.6-3.5.6-5.2 1.2-2.2.7-4 2.2-5 4.2-1.4-3.6-4.7-6.4-7.8-8.6-.9-.6-.8 2-.8 2.3-.1-.7-.1-.1-.3.3-.2.5-.4.9-.7 1.4-.5.9-.8 1.7-1 2.6-.1.2-.1.5-.1.7-.2-.7-.6-1.3-1-1.8-1.1-1.1-1.9.3-2.3 1.6-1.1-1.7-3.2-2.2-5.6-2.2-.4 0-.6.5-.6.8-.3 1.1-.6 2.6-.5 4.1-2-1.3-4.5-1.2-6.4.5-1.7 1.5-2.2 3.8-1.9 6-.2.7 0 1.7.1 2.1 1 2.5 2.1 4.9 3.1 7.4.1.2.3.5.5.5h37.1c.2 0 .4-.3.5-.5 1-2.5 2.1-4.9 3.1-7.4.1-.1.1-.4.1-.6 3.7-4.9 1.9-12.4-.9-17.1zm-.4 3.4c2 3.5 3 8.3.1 11.5h-5.3c.8-1 1.6-2.1 2.2-3.2 1-1.7 2.2-3.5 2.5-5.5.1-.7-.2-1.5-.5-1.8.4-.2.8-.6 1-1zm-18.1 11.5c-.3-2.1 2.3-3.6 4.1-3.6 1.8 0 4.5 1.5 4.1 3.6h-8.2zm16.4-10c0 .1-.1.3-.1.5-.2 1.5-1.6 3.3-2.5 4.5-1.2 1.8-2.6 3.6-4.3 4.9 0-2.6-1-5.3-3.4-6.3 2.8-2.2 7.4-1.9 10.3-3.6zm-20.3-1.3c.1-.3.2-.5.2-.8 2.1 1.6 4.3 3.4 5.7 5.7-.8.3-1.5.9-2 1.6-.4-2-1.3-4-2.5-5.7-.4-.6-.8.2-.9.6-.2.7-.2 1.6.2 2.2 1 1.4 2 3.3 2 5.1v.4c-.2.7-.2 1.5-.2 2.3h-2.5c.6-1.9.6-4-.1-5.9-.5-1.3-1-1.5-1.5-1.1.3-1.6 1-2.9 1.6-4.4zm-7 5.8c.1.6.7 1.8 1.2.7.2-.5.5-1.7.8-2.1.4-.5 0-.5.5-.2.9.6.7 3.2.7 3.9 0 .4.4 2.2 1 1.4.1-.1.4-.7.8-1.3.1-.1.3-.3.3-.5.2-.3.4-.5.5-.5.8-.1-.3 3.2-.6 4.1h-8.3c-.5-.3-1.2-.9-1.8-1.4.5-.1 1-.2 1.3-.2 1-.1.9-2.7.2-3.1-1.2-.6-1.2-1.7-1-2.9 1.7.1 4.2.2 4.4 2.1zm-10 2.1c1.1-.3 2.2-.2 3.2.3-.3.5-.4 1.1-.3 1.9.1.4.3.8.5 1.2h-6.2c-.3-1.6 1.3-3 2.8-3.4zm36.4 10.7c-.1 0-.3 0-.6.1-1 .2-2.3 0-3.3 0h-28.5c-1.1 0-2.4.1-3.5 0-.4-.1-.6 0-.7 0l-.1-.1c-.9-.9-1.5-2.5-2-4.1h40.6c-.5 1.6-1 3.2-1.9 4.1z"}})])
          )
        }
      }
    